import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from 'react-router-dom';

const Read = () => {
  const [read, setRead] = useState([]);
const navigate = useNavigate('')
  const getData = () => {
    axios
      .get("https://646b154b7d3c1cae4ce32640.mockapi.io/crudapi")
      .then(result => {
        console.log(result.data);
        setRead(result.data);
      })
      .catch(err => {});
  };

  const handleDelete = (id) =>{ 
  if (window.confirm("Are you sure want to Delete")) {
    
        axios.delete(`https://646b154b7d3c1cae4ce32640.mockapi.io/crudapi/${id}`)
        .then((result) => {
            console.log("here is the id :",id);
            getData()
        }).catch((err) => {
            
        });
      }
  }
  const DataStore = (id,name,age,email) =>{
    localStorage.setItem("id",id);
    localStorage.setItem("name",name);
    localStorage.setItem("age",age);
    localStorage.setItem("email",email);
  }
  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md-12 ">
            <h2 className="text-center text-success">Read The Api Call Data</h2>
                <div className="d-flex justify-content-start align-items-center">
                <button className="btn btn-primary" onClick={()=>navigate('/crud')}>Create New</button>
                </div>
            <table className="w-100 border table table-bordered table-striped text-white">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Age</th>
                  <th>Email</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {read.map((item, index) => {
                  return (
                    <tr>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.age}</td>
                      <td>{item.email}</td>
                      <td>
                      <Link to='/edit'>
                        <button className="btn btn-primary" onClick={()=>DataStore(item.id,item.name,item.age,item.email)} >Edit</button>
                        </Link>
                      </td>
                      <td>
                        <button className="btn btn-danger" onClick={()=>{handleDelete(item.id)} }>Delete</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Read;
